"use client"

import { motion } from "framer-motion"
import { ReactNode } from "react"

interface SlideUpProps {
  children: ReactNode
  duration?: number
  delay?: number
  distance?: number
}

export function SlideUp({ children, duration = 0.5, delay = 0, distance = 50 }: SlideUpProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: distance }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: duration,
        delay: delay,
        ease: "easeOut",
      }}
    >
      {children}
    </motion.div>
  )
}
